export default ":host {\n  width: 100%;\n}\n";